/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostSavingsMetrics {
    getFixupPrototypeFunction() { return CostSavingsMetrics.fixupPrototype; }

    static newInstance(model: Partial<CostSavingsMetrics>): CostSavingsMetrics {
        let obj = Object.assign(new CostSavingsMetrics(), model);
        CostSavingsMetrics.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostSavingsMetrics>): CostSavingsMetrics {
        if (!model) return null;
        return CostSavingsMetrics.newInstance(<CostSavingsMetrics> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostSavingsMetrics) {
        if (!obj) return;

        models.CostSavingsMetrics.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostSavingsMetrics): boolean {
        Object.setPrototypeOf(obj, CostSavingsMetrics.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.saving_per_month === undefined) {
            this.saving_per_month = 0;
        }
    }

    /**
     * Cost of Savings per Month
     */
    saving_per_month: number;

    /**
     * Name of the metric
     */
    metric_name: string;

}
